import React from 'react'
import { avatarStorage_LINK } from '../../api/ApiUrl'
import Avatar from '../layout/Avatar'
import { LongBreak, Salah, ShortBreak, Washroom } from '../layout/Icons'

const UserBubbles = ({user}) => {

    const setRingColor=(id)=>{
        if(id==0){
            return 'ring-green-400'
        }else if(id==1){
            return 'ring-indigo-800'
        }else if(id==2){
            return 'ring-orange-500'
        }else if(id==3){
            return 'ring-red-500'
        }else if(id==4){
            return 'ring-cyan-500'
        }else if(id==-1){
            return 'ring-slate-200 dark:ring-slate-700 opacity-50'
        }
    }

  return (
    <div className={`${setRingColor(user.activity)} messenger-user-bubble group`}>
        {user.photoUrl!=null?
        <img src={`${avatarStorage_LINK}${user.photoUrl}`} className='messenger-user-bubble-img' alt=''/>
        :
        <Avatar value={user.userName} width='6' height='6' color={'bg-blue-200 dark:bg-blue-800/70'} />
        }

        <Activity id={user.activity}/>
        <p className='absolute right-0 z-[160] px-2 py-1 text-xs font-semibold text-white transition-all duration-150 ease-in-out origin-bottom-right scale-0 rounded-md shadow-lg pointer-events-none -top-8 group-hover:scale-100 bg-slate-700 whitespace-nowrap'>{user.userName}</p>
    </div>
  )
}

const Activity=({id})=>{
    return (
        <div className='absolute -right-1 -top-1'>
        {id==1 && 
        <div className='w-4 h-4 p-0.5 text-white bg-indigo-800 rounded-full'>
            <Washroom iconClass={'w-3 h-3'}/>
        </div>
        }

        {id==2 && 
         <div className='w-4 h-4 p-0.5 text-white bg-orange-500 rounded-full'>
         <ShortBreak iconClass={'w-3 h-3'}/>
        </div>
        }

        {id==3 && 
        <div className='w-4 h-4 p-0.5 text-white bg-red-500 rounded-full'>
        <LongBreak iconClass={'w-3 h-3'}/>
        </div>
        }

        {id==4 && 
         <div className='w-4 h-4 p-0.5 text-white bg-cyan-500 rounded-full'>
        <Salah iconClass={'w-3 h-3'}/>
        </div>
        }
        </div>
    )
}

export default UserBubbles
